<script setup lang="ts">
import HistoryRunCard from './HistoryRunCard.vue'

import { useInsightActionHistory } from '../composables/useInsightActionHistory'
import type { RunListRow } from '../models/insightAction.types'
import { useInsightActionStore } from '../stores/insightActionStore'

import { useI18n } from '@/shared/i18n'

const { t } = useI18n()
const store = useInsightActionStore()
const history = useInsightActionHistory()

function labelFor(run: RunListRow): string {
  const group = store.groups.find((candidate) => candidate.key === run.groupKey)
  return group?.label || run.groupKey.replaceAll('_', ' ')
}
</script>

<template>
  <div class="insight-action-history grid gap-sm min-w-0">
    <p
      v-if="store.historyLoading && !store.history.length"
      class="m-0 py-lg text-center text-xs text-muted"
    >
      {{ t('insightActions.history.loading') }}
    </p>

    <div v-else-if="!store.history.length" class="py-xl text-center" data-testid="history-empty">
      <p class="m-0 text-sm font-semibold">{{ t('insightActions.history.emptyTitle') }}</p>
      <p class="mt-2xs mb-0 text-xs text-muted">{{ t('insightActions.history.emptyBody') }}</p>
    </div>

    <template v-else>
      <HistoryRunCard
        v-for="run in store.history"
        :key="run.runId"
        :run="run"
        :label="labelFor(run)"
        :expanded="store.expandedRuns.includes(run.runId)"
        :detail="store.runDetails[run.runId] ?? null"
        @toggle="history.toggle($event)"
        @revert-item="history.revertItem(run.runId, $event)"
        @revert-run="history.revertRun(run.runId)"
        @cancel-item="history.cancelItem(run.runId, $event)"
      />

      <p class="m-0 text-2xs text-muted">{{ t('insightActions.history.scopeNote') }}</p>
    </template>
  </div>
</template>
